<template>
    <nav class=" h-12  w-1/2 md:w-full flex justify-end ml-auto ">
        <button @click="mobileNavigationIsOpen = true" class="md:hidden ">
            <svg xmlns="http://www.w3.org/2000/svg" class="fill-current h-6 w-6" :class="hamburgerColor" viewBox="0 0 448 512">
              <path d="M0 84V44c0-8.837 7.163-16 16-16h416c8.837 0 16 7.163 16 16v40c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16zm16 144h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 256h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0-128h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"/>
            </svg>
        </button>
        <transition name="overlay">
            <button v-show="mobileNavigationIsOpen" class="fixed cursor-default md:hidden w-full h-screen bg-blue-900 opacity-90 inset-0 z-60" @click="mobileNavigationIsOpen = false" ></button>
        </transition>
        <div :class="mobileNavigationIsOpen?'sidebarOpen':''" class="sidebar w-80 bg-beige md:bg-transparent right-0 top-0 h-screen md:flex justify-end fixed z-70 md:relative md:w-full md:bottom-auto md:h-auto">
            <div class=" h-16 md:h-auto flex items-center justify-between pr-4 border-blue-100 border-b md:border-0">
                <div class="pl-4 text-blue-200 md:hidden"><button title="Contact us now" class="button button--green" @click="openEmployeeModal">contact us now</button></div>
                <button class=" md:hidden" @click="mobileNavigationIsOpen = false">

                    <svg xmlns="http://www.w3.org/2000/svg" class="text-blue-900 fill-current h-6 w-6" viewBox="0 0 448 512">
                      <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/>
                    </svg>
                </button>
            </div>
            <div v-if="navIsRendered" class="border-blue-100 border-b  p-5 md:px-3 md:py-0 md:items-center md:flex  md:border-0" v-for="navItem in navigationItems">
                <a :href="navItem.link" :title="navItem.name" :class="themeColor" class="block text-md text-blue-800 font-semibold ">{{ navItem.name}}</a>
                <div class="md:hidden">
                    <a class="block text-blue-700 text-lg py-2" :href="navSubItem.link" v-for="navSubItem in navItem.items" :title="navSubItem.title">{{ navSubItem.name}}</a>
                </div>
            </div>
            <div class="pl-4 text-blue-200 hidden md:block"><button title="Contact us now" class="button button--green"  @click="openEmployeeModal">contact us now</button></div>
        </div>
    </nav>
</template>

<script>
    export default {
        name: "Main-Navigation",
        props: {
            navItems: String,
            template: String
        },
        data: function(){
            return {
                'mobileNavigationIsOpen': false,
                'navIsRendered': false,
                'navIsScrolled': false,
                'hasBlueHeader' : false,
                'navigationItems' : {}
            }
        },
        mounted() {
            this.navigationItems = JSON.parse(this.navItems);
            this.navIsRendered = true;
            if (this.template == 'home' || this.template == 'services'  || this.template == 'areas' || this.template == 'about'){
                this.hasBlueHeader = true;
            }

        },
        methods: {
            handleSCroll(event) {
                if (window.scrollY > 100) {
                    this.navIsScrolled = true;
                } else {
                    this.navIsScrolled = false;
                }
            },
            openEmployeeModal(){
                EventBus.$emit('open-employee-modal')
            }
        },
        created() {
            const handleEscape = (e) => {
                if (e.key === 'Esc' || e.key === 'Escape' ) {
                    this.mobileNavigationIsOpen = false;
                }
                if (e.key === 'n') {
                    this.mobileNavigationIsOpen = !this.mobileNavigationIsOpen;
                }
            };
            window.addEventListener('scroll', this.handleSCroll);
            document.addEventListener('keydown', handleEscape);
        },
        computed: {
            themeColor: function(){
                if (this.hasBlueHeader){
                    return 'md:text-white';
                } else {
                    return 'md:text-blue-800';
                }
            },
            hamburgerColor: function(){
                if (this.hasBlueHeader){
                    return  'text-white';
                } else {
                    return 'text-blue-800';
                }
            },
        },
        destroyed () {
            window.removeEventListener('scroll', this.handleSCroll);
        }
    }
</script>
<style>

</style>
